import en from "./en_US";
import es from "./es_ES";

export default {
  ...en,
  ...es,
};
